import { VideoMediaCenterMenuAudioColumn } from './video-media-center-menu-audio-column'
import { VideoMediaCenterMenuSubtitlesColumn } from './video-media-center-menu-subtitles-column'

const { videojs } = global
const Component = videojs.getComponent('Component')

/**
 * Initialize audio and subtitles settings columns
 * @class
 * @extends Component
 */
// eslint-disable-next-line import/prefer-default-export
export class VideoMediaCenterMenuContent extends Component {
  /**
   * @param {Player|Object} player
   * @returns {void}
   */
  constructor (player, options) {
    super(player, { ...options, className: 'vjs-media-center-menu-content' })

    this.#addAudioColumn()
    this.#addSubtitlesColumn()
  }

  /**
   * @returns {void}
   */
  #addAudioColumn () {
    const column = new VideoMediaCenterMenuAudioColumn(this.player())
    this.addChild(column)
  }

  /**
   * @returns {void}
   */
  #addSubtitlesColumn () {
    const column = new VideoMediaCenterMenuSubtitlesColumn(this.player())
    this.addChild(column)
  }
}
